// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fps-page {
    min-height: 100vh;
    min-height: -webkit-fill-available;
    background: #f7fafc;
    display: flex;
    flex-direction: column;
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
}

.fps-header {
    background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
    color: white;
    padding: max(env(safe-area-inset-top, 16px), 16px) 20px 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    position: sticky;
    top: 0;
    z-index: 10;
}

.fps-header h1 {
    font-size: 1.05rem;
    font-weight: 700;
    margin: 0;
    flex: 1 1;
}

.fps-back-btn {
    background: rgba(255,255,255,0.2);
    border: none;
    color: white;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}

.fps-back-btn:active {
    opacity: 0.8;
}

.fps-loading {
    text-align: center;
    padding: 40px 20px;
    color: #718096;
}

.fps-content {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 20px;
}

.fps-card {
    background: white;
    border-radius: 16px;
    padding: 32px 24px;
    text-align: center;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
    width: 100%;
    max-width: 340px;
}

.fps-card-icon {
    font-size: 3.5rem;
    margin-bottom: 16px;
}

.fps-card-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #2d3748;
    margin-bottom: 8px;
    line-height: 1.3;
}

.fps-card-meta {
    font-size: 0.8rem;
    color: #718096;
    margin-bottom: 24px;
}

.fps-open-btn {
    background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
    color: white;
    border: none;
    padding: 14px 32px;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    width: 100%;
    transition: opacity 0.15s;
    appearance: none;
}

.fps-open-btn:active {
    opacity: 0.85;
}

.fps-empty {
    text-align: center;
    padding: 40px 20px;
    color: #718096;
}

.fps-empty-icon {
    font-size: 3rem;
    margin-bottom: 16px;
}

.fps-empty p {
    margin: 0 0 8px 0;
    font-weight: 600;
}

.fps-empty-hint {
    font-size: 0.83rem;
    color: #a0aec0;
}


@media (max-width: 360px) {
    .fps-header h1 {
        font-size: 0.95rem;
    }
    .fps-back-btn {
        padding: 6px 10px;
        font-size: 0.85rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FichaProcedimentosSeguranca.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,iEAAiE;IACjE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;IACvC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,yBAAyB;IAEzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ","sourcesContent":[".fps-page {\n    min-height: 100vh;\n    min-height: -webkit-fill-available;\n    background: #f7fafc;\n    display: flex;\n    flex-direction: column;\n    max-width: 600px;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.fps-header {\n    background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n    color: white;\n    padding: max(env(safe-area-inset-top, 16px), 16px) 20px 16px 20px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.fps-header h1 {\n    font-size: 1.05rem;\n    font-weight: 700;\n    margin: 0;\n    flex: 1;\n}\n\n.fps-back-btn {\n    background: rgba(255,255,255,0.2);\n    border: none;\n    color: white;\n    padding: 8px 12px;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    white-space: nowrap;\n}\n\n.fps-back-btn:active {\n    opacity: 0.8;\n}\n\n.fps-loading {\n    text-align: center;\n    padding: 40px 20px;\n    color: #718096;\n}\n\n.fps-content {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px 20px;\n}\n\n.fps-card {\n    background: white;\n    border-radius: 16px;\n    padding: 32px 24px;\n    text-align: center;\n    box-shadow: 0 4px 16px rgba(0,0,0,0.08);\n    width: 100%;\n    max-width: 340px;\n}\n\n.fps-card-icon {\n    font-size: 3.5rem;\n    margin-bottom: 16px;\n}\n\n.fps-card-title {\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: #2d3748;\n    margin-bottom: 8px;\n    line-height: 1.3;\n}\n\n.fps-card-meta {\n    font-size: 0.8rem;\n    color: #718096;\n    margin-bottom: 24px;\n}\n\n.fps-open-btn {\n    background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n    color: white;\n    border: none;\n    padding: 14px 32px;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n    width: 100%;\n    transition: opacity 0.15s;\n    -webkit-appearance: none;\n    appearance: none;\n}\n\n.fps-open-btn:active {\n    opacity: 0.85;\n}\n\n.fps-empty {\n    text-align: center;\n    padding: 40px 20px;\n    color: #718096;\n}\n\n.fps-empty-icon {\n    font-size: 3rem;\n    margin-bottom: 16px;\n}\n\n.fps-empty p {\n    margin: 0 0 8px 0;\n    font-weight: 600;\n}\n\n.fps-empty-hint {\n    font-size: 0.83rem;\n    color: #a0aec0;\n}\n\n\n@media (max-width: 360px) {\n    .fps-header h1 {\n        font-size: 0.95rem;\n    }\n    .fps-back-btn {\n        padding: 6px 10px;\n        font-size: 0.85rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
